import React from 'react';
import { Tooltip, TooltipProps } from 'antd';
import { StyledButton } from '@src/pages/main/components/MappingEntrance/styled';
import LockSvg from 'icons/home/lock.svg';
import { useCreatePermissions } from '@src/hooks/usePermissions';
import Icon from '@ant-design/icons';

interface IPermissionButton {
  onClick?: (e) => void;
  onConfirm?: () => void;
  tooltip?: TooltipProps['title'];
  lackPermissionToolTip?: TooltipProps['title'];
  children?: React.ReactNode;
  styleType?: 'styled' | 'default';
  type?: 'primary';
  style?: React.CSSProperties;
  disabledStyle?: React.CSSProperties;
}

const LackPermissionToolTip =
  'Non-Admin Permission, Please contact your Conviva representative to activate.';

const PermissionButton: React.FC<IPermissionButton> = ({
  onClick,
  onConfirm,
  tooltip,
  lackPermissionToolTip,
  children,
  styleType,
  type,
  style,
  disabledStyle,
}) => {
  const hasCreate = useCreatePermissions();

  const handleClick = (e) => {
    hasCreate && onClick?.(e);
  };
  const handleConfirm = () => {
    hasCreate && onConfirm?.();
  };

  return (
    <Tooltip
      title={hasCreate ? tooltip : lackPermissionToolTip ?? LackPermissionToolTip}
      overlayStyle={{ maxWidth: 'fit-content' }}
      overlayInnerStyle={{ maxWidth: 'fit-content' }}
      arrow
      placement="topLeft"
    >
      {styleType === 'styled' ? (
        <StyledButton
          onClick={handleClick}
          type={type}
          disabled={!hasCreate}
          data-test-id="map_new_event_entry_btn"
          style={style}
        >
          {children}
          {!hasCreate && (
            <Icon
              component={LockSvg}
              style={{ marginLeft: '6px', color: type === 'primary' ? '#fff' : '#0046FF' }}
            />
          )}
        </StyledButton>
      ) : (
        <span>
          {children &&
            React.isValidElement(children) &&
            React.cloneElement(
              children as React.ReactElement,
              {
                onClick: handleClick,
                onConfirm: handleConfirm,
                disabled: !hasCreate || children.props.disabled,
                className: `${children.props.className}`,
                style: {
                  ...children.props.style,
                  ...style,
                  ...(!hasCreate
                    ? { cursor: 'not-allowed', color: 'rgba(0, 0, 0, 0.25)', ...disabledStyle }
                    : {}),
                },
              },
              <>
                {React.isValidElement(children.props.children)
                  ? React.cloneElement(children.props.children as React.ReactElement, {
                      disabled: !hasCreate,
                      style: {
                        ...children.props.children.props.style,
                        ...style,
                        ...(!hasCreate
                          ? {
                              cursor: 'not-allowed',
                              color: 'rgba(0, 0, 0, 0.25)',
                              ...disabledStyle,
                            }
                          : {}),
                      },
                    })
                  : children.props.children}
                {!hasCreate && <Icon component={LockSvg} style={{ marginLeft: '6px' }} />}
              </>,
            )}
        </span>
      )}
    </Tooltip>
  );
};

export default PermissionButton;
